// components/icons/icons.ts
import { type LucideProps } from 'lucide-react';
import { icons } from './icons';

export type IconName = keyof typeof icons;

export function LucideIcon({ name, ...props }: { name: IconName } & LucideProps) {
  const Icon = icons[name];
  return Icon ? <Icon {...props} /> : null;
}
